import React from 'react';
import { Alert, Button, Empty, Skeleton } from 'antd';
import { V2ApiError } from '../../services/v2';

interface RequestStateProps {
    loading: boolean;
    error?: V2ApiError | null;
    empty?: boolean;
    onRetry: () => void;
    children: React.ReactNode;
}

const RequestState = ({ loading, error, empty, onRetry, children }: RequestStateProps) => {
    if (loading)
        return (
            <div className="v2-panel">
                <Skeleton active paragraph={{ rows: 7 }} />
            </div>
        );
    if (error)
        return (
            <Alert
                className="v2-request-error"
                type="error"
                showIcon
                message={error.message}
                description={
                    <div>
                        {error.requestId
                            ? `请求编号：${error.requestId}`
                            : '请检查网络或当前账号权限后重试。'}{' '}
                        <Button size="small" onClick={onRetry}>
                            重试
                        </Button>
                    </div>
                }
            />
        );
    if (empty)
        return (
            <div className="v2-panel">
                <Empty description="暂无符合条件的数据" />
            </div>
        );
    return <>{children}</>;
};

export default RequestState;
